module.exports = __webpack_public_path__ + "static/media/6.13.38305186.png";